import { render, staticRenderFns } from "./PaginatedSection.vue?vue&type=template&id=25b57c5a&"
import script from "./PaginatedSection.vue?vue&type=script&lang=js&"
export * from "./PaginatedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports